import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

import HeroHeadline from "../../components/heroHeadline/heroHeadline";
import mapKontentItem from "../../utils/mapKontentItem";
import FaqOverviewComponent from "../faq/faqOverviewComponent";
import MainLayout from "../layout/mainLayout";
import BreadcrumbGenerator from "../navigation/breadcrumbGenerator";
import SubNavigationGenerator from "../navigation/subNavigationGenerator";
import TabNavigationGenerator from "../virtualDrive/tabNavigationGenerator";

const KontentItemVdHelp = ({ data: { page } }) => (
  <MainLayout>
    <SubNavigationGenerator id={page.id} />

    <HeroHeadline
      data={page.elements.hero_image.value.length > 0
        ? page.elements.hero_image
        : null}
      tabNavigation={<TabNavigationGenerator id={page.id} />}
    >
      {page.elements.hero_headline.value}
    </HeroHeadline>

    <BreadcrumbGenerator id={page.id} />

    <FaqOverviewComponent items={page.elements.faq_groups} variant="virtual-drive-help" />

    {page.elements.eyecatcher_contact.value.length > 0
      ? mapKontentItem(page.elements.eyecatcher_contact.value[0])
      : null}

  </MainLayout>
);

export const query = graphql`
  query ($id: String!) {
    page: kontentItemVdHelp(id: {eq: $id}) {
      id
      elements {
        metadata__meta_description {
          value
        }
        metadata__twitter_title {
          value
        }
        metadata__twitter_site {
          value
        }
        metadata__twitter_image {
          value {
            url
          }
        }
        metadata__twitter_description {
          value
        }
        metadata__twitter_creator {
          value
        }
        metadata__og_title {
          value
        }
        metadata__og_image {
          value {
            url
          }
        }
        metadata__og_description {
          value
        }
        metadata__meta_title {
          value
        }
        hero_headline {
          value
        }
        hero_image {
          value {
            ...KontentItemImage
          }
        }
        faq_groups {
          value {
            ...FaqOverviewComponent
          }
        }
        eyecatcher_contact {
          value {
            internal {
              type
            }
            ...KontentItemEyecatcherContact
            ...KontentItemEyecatcher
          }
        }
      }
    }
  }
`;

export { GatsbyHead as Head } from "../../components/gatsbyHead/gatsbyHead";

KontentItemVdHelp.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemVdHelp;
